import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation } from 'swiper/modules';
export default class HeroInternal {
    constructor() {
        this.header = document.querySelector('header');

        this.section = document.querySelector('.components-block-hero-internal-links');
        this.slider = this.section.querySelector('.swiper');
        this.navigationPrev = this.section.querySelector('.slider-button-prev');
        this.navigationNext = this.section.querySelector('.slider-button-next');

        this.ready();
        this.positionCheck();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation],
            grabCursor: true,
            slidesPerView: 'auto',
            spaceBetween: '32px',
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
        });
    }

    positionCheck() {
        let sectionPosition = this.section.getBoundingClientRect().top;
        document.addEventListener('scroll', (e) => {
            let scrollBarPosition = window.scrollY;
            if (scrollBarPosition > 390) {
                this.section.dataset.fixed = 'true';
                this.header.classList.add('hiddenNav');
                this.section.classList.add('fixedNav'); // Adiciona uma classe de destaque, por exemplo
            } else {
                this.section.dataset.fixed = 'false';
                this.section.classList.remove('fixedNav'); // Remove a classe de destaque, por exemplo
                this.header.classList.remove('hiddenNav');
            }
        });
    }
}

if (document.querySelector('.components-block-hero-internal-links')) {
    new HeroInternal();
}
